import Button from "../../Elements/Button/Button.js";
import SimpleContent from "../../Structure/ModalManager/SimpleContent.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

import "./ForBusinessOnlyModal.scss";

const ForBusinessOnlyModal = () => {
  const { getTextByKey } = useContent();

  return (
    <SimpleContent
      image={{ name: "magic-box", ext: "png" }}
      title="available-for-business-only-title"
      message="available-for-business-only-message"
      actionButton={
        <LinkToNewTab page="purchase/business/yearly">
          <Button>{getTextByKey("upgrade")}</Button>
        </LinkToNewTab>
      }
    ></SimpleContent>
  );
};

export default ForBusinessOnlyModal;
